import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import 'rxjs/Rx';

@Injectable()
export class AuthService {

    authKey: string = "auth";
    clientId: string = "MorphicaDental";

    constructor(
        private http: HttpClient) {

        this.initSessions();

    }

    // performs the login
    login(username: string, password: string): Observable<any> {

        var url = "api/token/auth";
        var data = {
            UserName: username,
            Password: password,
            ClientId: this.clientId,
            // required when signing up with username/password
            GrantType: "password",
            // space-separated liat of scopes for which the token is issued
            Scope: "offline_access profile email"
        }

        return this.getAuthFromServer(url, data);

    }

    // performs the login as user
    loginAsUser(user_username: string, sa_username: string, sa_password: string): Observable<boolean> {

        var url = "api/token/auth";
        var data = {
            UserName: user_username,
            SAUserName: sa_username,
            SAPassword: sa_password,
            ClientId: this.clientId,
            // required when signing up with username/password
            GrantType: "password",
            // space-separated liat of scopes for which the token is issued
            Scope: "offline_access profile email"
        }

        return this.getAuthFromServer(url, data);

    }

    // performs logout
    logout(): boolean {
        this.setAuth(null);
        return true;
    }

    // persists auth into sessionStorage or removes it if a NULL argument is given
    setAuth(auth: TokenResponse | null): boolean {
        if (auth) {
            sessionStorage.setItem(
                this.authKey,
                JSON.stringify(auth));
        }
        else {
            sessionStorage.removeItem(this.authKey);
        }

        return true;
    }

    // retrieves the auth JSON object (or NULL if none)
    getAuth(): TokenResponse | null {
        var i = sessionStorage.getItem(this.authKey);
        if (i) {
            return JSON.parse(i);
        }
        return null;
    }

    // returns TRUE if the user is logged in, FALSE otherwise
    isLoggedIn(): boolean {
        return sessionStorage.getItem(this.authKey) != null;
    }

    isTokenExpired(): boolean {

        const auth = this.getAuth();
        if (!auth || !auth.token) return true;

        // Decodifica la parte "payload" del token
        const parts = auth.token.split('.');
        if (parts.length !== 3) return true;

        const payload = JSON.parse(window.atob(parts[1]));

        // Il campo 'exp' è in secondi, JavaScript lavora in millisecondi
        const expirationDate = payload.exp * 1000;
        const now = new Date().getTime();

        return now > expirationDate;
    }

    // try to refresh token
    refreshToken(): Observable<boolean> {

        var url = "api/token/auth";
        var data = {
            ClientId: this.clientId,
            // required when signing up with username/password
            GrantType: "refresh_token",
            RefreshToken: this.getAuth()!.refreshToken,
            // space-separated list of scopes for which the token is issued
            Scope: "offline_access profile email"
        };

        return this.getAuthFromServer(url, data);

    }

    // verifies the two factor authentication code
    verify2fa(code: string, rememberMe: boolean): Observable<boolean> {

        var url = "api/token/verifytwofactor";
        var data = {
            Code: code,
            RememberDevice: rememberMe,
            ClientId: this.clientId
        };

        return this.getAuthFromServer(url, data);
    }

    // retrieve the access & refresh tokens from the server
    getAuthFromServer(url: string, data: any): Observable<boolean|any> {

        return this.http.post<TokenResponse>(url, data)
            .map((res) => {

                if (res) {

                    // logged in
                    if (res.token) {
                        this.setAuth(res);
                        return { success: true };
                    }
                    // requires 2FA
                    else if (res.requiresTwoFactor) {
                        return { success: false, requiresTwoFactor: true };
                    }
                    else if (res.error) {
                        throw Observable.throw(res.error);
                    }

                }

                throw Observable.throw('Unauthorized');
                
            })
            .catch(error => {
                throw Observable.throw(error);
            });

    }

    initSessions() {

        if (!sessionStorage.length) {
            // Ask other tabs for session storage
            localStorage.setItem('getSessionStorage', Date.now().toString());
        };

        window.addEventListener('storage', function (event) {

            //console.log('storage event', event);

            if (event.key == 'getSessionStorage') {

                // Some tab asked for the sessionStorage -> send it

                localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage));
                localStorage.removeItem('sessionStorage');

            } else if (event.key == 'sessionStorage' && !sessionStorage.length) {

                // sessionStorage is empty -> fill it

                var data = JSON.parse(event.newValue),
                    value;

                for (var key in data) {
                    sessionStorage.setItem(key, data[key]);
                }
            }
        });

    }

    isDentalLab(): boolean {

        return this.getAuth().dentalLab;

    }

    isDentalClinic(): boolean {

        return this.getAuth().dentalClinic;

    }

}


// WEBPACK FOOTER //
// ./ClientApp/app/_services/auth.service.ts